import { render, staticRenderFns } from "./ForecastUOApp9.vue?vue&type=template&id=1056a8a1&"
import script from "./ForecastUOApp9.vue?vue&type=script&lang=js&"
export * from "./ForecastUOApp9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports